import React, { useEffect, useState } from "react";
import { NodeViewWrapper } from "@tiptap/react";
import { ActionButton, IconComponent } from "../../../components";
import { useLocale } from "../../../locales";
import "./htmleditor.css";
import FormButtons from "../../../../Molecule/Buttons/FormButtons";

function HTMLEditorButton({ editor, content, setContent }) {
	const [htmlContent, setHtmlContent] = useState(editor?.options?.content || "");
	const [isModalOpen, setModalOpen] = useState(false);

	const openModal = () => {
		setHtmlContent(editor?.getHTML());
		setModalOpen(true);
	};

	const saveHTMLContent = () => {
		const revisedHtml = htmlContent;
		setContent(revisedHtml);
		setHtmlContent(revisedHtml);
		editor.commands.setContent(revisedHtml);
		setModalOpen(false);
	};

	const closeModal = () => {
		setModalOpen(false);
	};

	return (
		<NodeViewWrapper>
			<ActionButton onClick={openModal} tooltip={"Edit HTML"}>
				<IconComponent name="Code" className="w-6 h-10" />
			</ActionButton>

			{isModalOpen && (
				<div className="modal-content">
					<h3>Edit HTML</h3>
					<textarea
						value={htmlContent}
						onChange={e => setHtmlContent(e.target.value)}
						rows="100"
						cols="50"
						className="html-textarea"
					/>
					<FormButtons onSave={saveHTMLContent} onCancel={closeModal} />
				</div>
			)}
		</NodeViewWrapper>
	);
}

export default HTMLEditorButton;
